import { DataBean } from "../DataBean";

export class ErrorDetails extends DataBean {

  public async getErrorDetailsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getErrorDetailsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteErrorDetails(iderrordetails: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteErrorDetails_Number", [iderrordetails]);
  }

  public async updateErrorDetails(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.ErrorDetails_updateErrorDetails_com.orange.finance.processcontract.bean.ErrorDetails",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.ErrorDetails",
        },
      ]
    );
  }
}
